import React from 'react';

import './MainDash.scss';

const MainDash = ({
    children
  }) => {
    return (
      <div className="MainDash">
        {children}
      </div>
    );
  };
  
export default MainDash;

